function addZero(val) {
  return `0${val}`;
}

function parsePrice(value, dropper) {
  const prefix = parseInt(value / 100, 10);
  const postfix = value % 100;
  if (!dropper) {
    return `${prefix},${postfix < 10 ? addZero(postfix) : postfix}`;
  }
  return `${prefix}${dropper}${postfix < 10 ? addZero(postfix) : postfix}`;
}

const filters = {
  install(Vue, options) { // eslint-disable-line no-unused-vars
    Vue.filter('price', (value, dropper) => {
      if (typeof value !== 'number') {
        const data = value.toString().replace(/[^\d]+/, '');
        return parsePrice(parseInt(data, 10), dropper);
      }
      return parsePrice(value, dropper);
    });
  },
};

export default filters;
